export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const USER_UPDATED = 'USER_UPDATED';